module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/128-spain-75faaf4db696243a6a7b5e1c21eedbec.svg";